<div class="backspinner" *ngIf="mode === 'indeterminate'">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
<!-- New Header -->
<header class="header" [style.display]="showHeader ? 'block' : 'none' ">
  <div class="primary-header text-center"
    *ngIf="globalServices?.isActivePlan == 0 && globalServices.firstname && this.globalServices.isLoggedIn">
    <p class="text-capitalize cursorHand" (click)="goToSubscriptionPage()">
      Welcome back, {{ globalServices.firstname }}! Let's complete your app membership.
    </p>
  </div>
  <div class="container-fluid">
    <nav class="navbar navbar-expand-md">
      <a class="navbar-brand cursorHand">
        <img src="https://www.mylifewell.com/assets/images/logo/300.png" alt="mylifewell" (click)="logoClick()">
      </a>
      <form class="header-searchform d-none d-md-flex">
        <div class="form-group position-relative mr-5">
          <select class="form-control search-control" id="searchSelect1" (change)="searchInArea($event)">
            <option value="all">All</option>
            <option value="digital">Live Well</option>
            <option value="travel">Travel Well</option>
            <option value="shop">Shop Well</option>
          </select>
          <input type="text" class="form-control" id="searchtxt" aria-describedby="emailHelp" placeholder="Search"
            name="searchText" [(ngModel)]="searchText" (keyup)="searchTextEnter($event)">
          <button type="submit" class="search-btn" (click)="searchNow(searchText)">
            <img src="assets/images/search-icn.png" alt="mylifewell">
          </button>
        </div>
        <!-- <button type="button" class="btn started-btn" (click)="navigationToggleButton()">
          <a class="nav-link btn-space" id="store" style="color:#fff">
            Member Sign up
          </a>
        </button> -->
        <button type="button" class="btn started-btn">
          <a class="nav-link btn-space" routerLink="/membership/app" id="store" style="color:#fff">
            Member Sign up
          </a>
        </button>
        <button type="button" class="btn started-btn">
          <a class="nav-link btn-space"
            (click)="goToUrl('https://business.mylifewell.com/holistic-wellness-marketplace/')" id="store">
            Coach Sign-Up
          </a>
        </button>
        <!-- <li (click)="navigationToggleButton()">
          <a class="nav-link" routerLink="/membership/app" id="store">
            membership
          </a>
        </li>
        <li>
          <a class="nav-link" (click)="goToUrl('https://business.mylifewell.com/holistic-wellness-marketplace/')" id="store">
            Coach Sign-Up
          </a>
        </li> -->
      </form>
      <div class="collapse navbar-collapse show">
        <ul class="navbar-nav mr-auto">
          <li class="d-md-none">
            <a class="navbar-brand cursorHand">
              <img src="https://www.mylifewell.com/assets/images/logo/300.png" alt="">
            </a>
            <span class="close-icon" (click)="navigationToggleButton()">
              <img src="assets/images/close-icn.png" alt="">
            </span>
          </li>
          <li (click)="moveToPrograms($event)">
            <a class="nav-link"  id="store">
              Courses
            </a>
          </li>
          <li>
            <a class="nav-link" (click)="moveToOneToOne($event)"
              id="store">
              Coaching packages
            </a>
          </li>
          <li>
            <a href="/travel" class="nav-link" 
              id="store">
              Travel Well
            </a>
          </li>
          <li>
            <a class="nav-link" (click)="goToUrl('https://business.mylifewell.com/')" id="store">
              B2B Solutions
            </a>
          </li>
          <!-- <li (click)="navigationToggleButton()">
            <a class="nav-link" routerLink="/membership/app" id="store">
              membership
            </a>
          </li>
          <li>
            <a class="nav-link" (click)="goToUrl('https://business.mylifewell.com/holistic-wellness-marketplace/')" id="store">
              Coach Sign-Up
            </a>
          </li> -->

          <!-- For Mobile ONLY visble  -->
          <li *ngIf="globalServices.isLoggedIn" class="d-md-none">
            <a class="nav-link" href="myaccount/profile">
              My Profile
            </a>
          </li>
          <li class="d-md-none" (click)="navigationToggleButton()">
            <a class="nav-link" routerLink="/contact">
              Help & Support
            </a>
          </li>
          <li class="signin d-md-none">
            <a *ngIf="!globalServices.isLoggedIn"
              (click)="openSectionForLogin();openloginmodal();navigationToggleButton()" class="btn signin-btn">
              Sign In
            </a>
            <a *ngIf="globalServices.isLoggedIn" (click)="logOut()" class="btn signin-btn">
              Logout
            </a>
          </li>
        </ul>
      </div>
      <div class="navbar-text d-none navbar-controls d-md-flex align-items-md-center">
        <div class="global-search" [ngClass]="{'open-search':openSearch}">

        </div>
        <div class="available user-settings-menu d-md-inline-block" id="user-settings-menu"
          *ngIf="globalServices.isLoggedIn">
          <a (click)="openSectionForLogout()">
            <span class="prof-name-txt cursorHand">
              <span class="user-profile-icn" *ngIf='globalServices.imgSrc'>
                <img [src]="globalServices.imgSrc" alt="prof-img">
              </span>{{globalServices.firstname}}
            </span>
          </a>
          <ul class="user-setting  text-left d-none cursorHand" id="user-setting">
            <li><a routerLink="home">My Dashboard</a></li>
            <li><a href="/myaccount">My Account</a></li>
            <li><a (click)="logOut()">Log Out</a></li>
          </ul>
        </div>
        <span class="desk-notification d-none d-md-inline-block">
          <a href="/cart"><i class="icon-cart"></i></a>
          <span class="notification d-none d-md-flex">{{globalServices.cartquantity}}</span>
        </span>
        <a *ngIf="!globalServices.isLoggedIn" (click)="openSectionForLogin();"
          class="btn login-btn d-none d-md-inline-block">
          <span>Sign In</span>
        </a>
        <!-- Befor login pop up -->
        <div class="login-reg-popup d-none d-md-block" id="newSignInPopUp">
          <div class="popup-head d-flex justify-content-between align-items-center">
            <span class="urser-icn"><img src="assets/images/user-icn.png" alt=""></span>
            <div class="info">
              <div class="log-reg-txt cursorHand">
                <a (click)="openloginmodal();openSectionForLogin()">
                  Login
                </a>/
                <a (click)="openloginmodal();openSectionForLogin();">
                  Register
                </a>
              </div>
              <a routerLink="/membership/app" class="btn join-btn" *ngIf="!globalServices?.isLoggedIn">
                Join MyLifeWell
              </a>
            </div>
            <i class="icon-arrow"></i>
          </div>
          <ul class="user-nav-list">
            <li>
              <a href="/about-us" class="text-capitalize">
                <i class="icon-consultation"></i>
                <span>
                  About Us
                </span>
              </a>
            </li>
            <li>
              <a routerLink="/contact" class="text-capitalize">
                <i class="icon-support"></i>
                <span>
                  Help & Support
                </span>
              </a>
            </li>
          </ul>
        </div>
        <!-- After login pop up -->
        <div class="login-reg-popup d-none d-md-block" id="AfterNewSignInPopUp">
          <div class="popup-head d-flex justify-content-between align-items-center">
            <span class="urser-icn">
              <img [src]="globalServices.imgSrc" alt="prof-img">
            </span>
            <div class="info">
              <div class="log-reg-txt cursorHand">
                <a>
                  Hi {{globalServices.firstname}}
                </a>
              </div>

              <a routerLink="/membership/app" class="btn join-btn" *ngIf="!globalServices?.isLoggedIn">
                Join MyLifeWell
              </a>
            </div>
            <i class="icon-arrow"></i>
          </div>
          <ul class="user-nav-list">
            <li>
              <a href="myaccount/bookings" class="text-capitalize">
                <i class="icon-order"></i>
                <span>
                  My Orders
                </span>
              </a>
            </li>
            <li>
              <a href="myaccount/wishlist" class="text-capitalize">
                <i class="icon-wishlist"></i>
                <span>
                  Wishlist
                </span>
              </a>
            </li>

            <li>
              <a href="myaccount/profile" class="text-capitalize">
                <i class="icon-profile"></i>
                <span>
                  My Profile
                </span>
              </a>
            </li>
            <li>
              <a routerLink="/contact" class="text-capitalize">
                <i class="icon-support"></i>
                <span>
                  Help & Support
                </span>
              </a>
            </li>
            <li (click)="logOut()">
              <a class="text-capitalize cursorHand">
                <i class="icon-consultation"></i>
                <span>
                  Logout
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div class="mobile-nav-strip d-flex align-items-center justify-content-between d-md-none">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText"
        aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation"
        (click)="navigationToggleButton()">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="user-mob d-md-none">
        <a href="/cart"><i class="icon-cart"></i></a>
        <span class="notification">{{globalServices.cartquantity}}</span>
      </div>
    </div>
    <!-- new mob search -->
    <form class="header-searchform mob-header-search d-md-none">
      <div class="form-group">
        <select class="form-control search-control" id="searchSelect1" (change)="searchInArea($event)">
          <option value="all">All</option>
          <option value="digital">Live Well</option>
          <option value="travel">Travel Well</option>
          <option value="shop">Shop well</option>
        </select>
        <input type="text" class="form-control" id="searchtxt" aria-describedby="emailHelp" placeholder="Search"
          name="searchText" [(ngModel)]="searchText" (keyup)="searchTextEnter($event)">
      </div>
      <button type="submit" class="search-btn" (click)="searchNow(searchText)">
        <img src="assets/images/search-icn.png" alt="">
      </button>
    </form>
  </div>
  <div class="enquiry-poup">
    <app-modal-pop-up [responseMessage]="responseMessage" *ngIf="showAlert" (triggerCloseEvent)="triggerCloseEvent()">
    </app-modal-pop-up>
  </div>
</header>
<!-- New Header -->